export enum FilterSelect {
    DAY = 'День',
    WEEK = 'Неделя',
    MONTH = 'Месяц',
    QUARTER = 'Квартал',
    YEAR = 'Год',
    ALL = 'За все время',
}
